export default class ConflictError extends Error {
	public constructor() {
		super();
	}
}
